import { InjectionToken } from '@angular/core';

import { ISnBrandLogosConfig } from '../interfaces/brand-logos-config.interface';

export const SN_BRAND_LOGOS = new InjectionToken<ISnBrandLogosConfig>('SN_BRAND_LOGOS');
